import CustomerGroupTable from '../sections/table/CustomerGroupTable'
import useGetCustomersGroups from '../hooks/useGetCustomersGroups'
import {ProfitabilityContext} from '../context'
import useGetCustomers from '../hooks/useGetCustomers'
import useGetProfitability from '../hooks/useGetProfitability'
import {useState} from 'react'
import {useLocation} from 'react-router-dom'
import useGetCustomerGroupDropdown from '../hooks/useGetCustomerGroupDropdown'
import useGetCustomersGroupsChartData from '../hooks/useGetCustomersGroupsChartData'
import {useGetSalesRepDropdown} from '../hooks/useGetSalesRepDropdown'
import ProfitabilityHeader from '../sections/header/ProfitabilityHeader'
import ProfitabilityDashboardCharts from '../sections/charts/ProfitabilityDashboardCharts'
import CustomersTable from '../sections/table/CustomersTable'
import {Pagination} from '../../../utils/pagination'
import useGetIOrdersOverviewData from '../hooks/useGetIOrdersOverviewData'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function Profitability() {
  const location = useLocation()
  const searchParams = location.search
  const isFullView = searchParams.includes('view=dashboard-customers')
  const [dateRangeLable, setDateRangeLable] = useState<string>('Current Year')

  const {
    CustomersGroupsData: customersGroupsChartData,
    onDateChangeCustomersGroupsChart,
    isLoading: isCustomersGroupsChartLoading,
  } = useGetCustomersGroupsChartData()

  const {
    profitabilityData,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    pagination,
    onDateChangeCustomers,
    onChangeCustomerGroupFilter,
    onChangeSalesRepFilter,
    onDownloadCSV,
  } = useGetCustomers()

  const {customerGroups, isLoading: isCustomerGroupsLoading} = useGetCustomerGroupDropdown()
  const {salesReps, isLoading: isSalesRepDropdownLoading} = useGetSalesRepDropdown()

  const {
    CustomersGroupsData,
    onDateChangeCustomersGroups,
    filters: customersGroupsFilters,
    onSortingChange: onSortingChangeCustomersGroups,
    onChangeCustomerGroupFilter: onChangeCustomerGroupCustomersGroupsFilter,
    isLoading: isCustomersGroupsLoading,
  } = useGetCustomersGroups()

  const {
    profitabilitySummaryData,
    onDateChangeProfitabilitySummary,
    isLoading: isProfitabilitySummaryLoading,
  } = useGetProfitability()

  const {ordersOverviewData, isOrdersOverviewDataLoading, onOrdersOverviewDateChange} =
    useGetIOrdersOverviewData()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_group')

  const {
    entityPerformanceChartData: allEntityPerformanceChartData,
    isLoading: isAllEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onAllEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onAllEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onAllEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: allEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('all')

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
    onProfitTrendViewChange,
    onProfitTrendDateRangeChange,
    profitTrendFilters,
  } = useGetProfitTrend('customer_group')

  const {
    profitTrendChartData: customerTypeProfitTrendChartData,
    kpiData: customerTypeProfitTrendKpiData,
    weeklyBreakdownData: customerTypeProfitTrendWeeklyBreakdownData,
    isLoading: isCustomerTypeProfitTrendDataLoading,
    onProfitTrendIdChange: onCustomerTypeProfitTrendIdChange,
  } = useGetProfitTrend('customer')

  const contextValue = {
    isFullView,
    ordersOverviewData,
    isOrdersOverviewDataLoading,
    onOrdersOverviewDateChange,
    customersGroupsChartData,
    isCustomersGroupsChartLoading,
    onDateChangeCustomersGroupsChart,
    profitabilityData,
    isLoading,
    filters,
    onSearch,
    onSortingChange,
    onPageChange,
    onChangeCustomerGroupFilter,
    onChangeCustomerGroupCustomersGroupsFilter,
    pagination,
    onDateChangeCustomers,
    customersGroupsFilters,
    onSortingChangeCustomersGroups,
    onDateChangeCustomersGroups,
    onDateChangeProfitabilitySummary,
    salesReps,
    isSalesRepDropdownLoading,
    onChangeSalesRepFilter,
    onDownloadCSV,
    dateRangeLable,
    setDateRangeLable,
    CustomersGroupsData,
    isCustomersGroupsLoading,
    profitabilitySummaryData,
    isProfitabilitySummaryLoading,
    customerGroups,
    isCustomerGroupsLoading,
    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    allEntityPerformanceChartData,
    isAllEntityPerformanceChartDataLoading,
    onAllEntityPerformanceChartIdChange,
    onAllEntityPerformanceChartViewChange,
    onAllEntityPerformanceChartDateRangeChange,
    allEntityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
    onProfitTrendViewChange,
    onProfitTrendDateRangeChange,
    profitTrendFilters,

    // Customer Type Profit Trend Modal Data
    customerTypeProfitTrendChartData,
    customerTypeProfitTrendKpiData,
    customerTypeProfitTrendWeeklyBreakdownData,
    isCustomerTypeProfitTrendDataLoading,
    onCustomerTypeProfitTrendIdChange,
  }

  return (
    <ProfitabilityContext.Provider value={contextValue}>
      <ProfitabilityHeader />
      <ProfitabilityDashboardCharts />
      <CustomerGroupTable />
      <CustomersTable />
      {isFullView && <Pagination pagination={pagination} onPageChange={onPageChange} />}
    </ProfitabilityContext.Provider>
  )
}

export default Profitability
